import { useContext } from 'react';
import { ModuleNavigationContext, ModuleNavigationContextValue } from '@/contexts/ModuleNavigationContext';

/**
 * Hook to access module navigation context
 *
 * @throws {Error} If used outside of ModuleNavigationProvider
 * @returns Module navigation context value
 *
 * @example
 * ```tsx
 * const { moduleNav, setModuleNav } = useModuleNavigation();
 *
 * // In Layout.tsx to render navigation
 * {moduleNav?.isActive && (
 *   <ModuleNavigationBar navigation={moduleNav} />
 * )}
 * ```
 */
export function useModuleNavigation(): ModuleNavigationContextValue {
  const context = useContext(ModuleNavigationContext);

  if (!context) {
    throw new Error(
      'useModuleNavigation must be used within ModuleNavigationProvider. ' +
      'Make sure your component is wrapped with <ModuleNavigationProvider>.'
    );
  }

  return context;
}
